module.exports = __webpack_public_path__ + "static/media/tmnt.330aab6a.jpg";